import { Button, Theme } from '@material-ui/core'
import { ButtonProps } from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/styles'
import React, { ComponentProps, FC } from 'react'
import DownloadIcon from '../../common/customIcons/downloadIcon'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    background: '#F9F9F9',
    borderRadius: theme.spacing(0.5),
    border: `solid #D1D1D1 1px`,
    height: theme.spacing(4.5),
    padding: '0 30px',
    '& span': {
      color: 'black',
    },
    '&:hover': {
      // background: theme.palette.primary.main,
      '& span': {
        color: theme.palette.primary.main,
      },
    },
  },
}))

const DownloadButton: FC<ComponentProps<any> & ButtonProps> = props => {
  const { children } = props

  const classes = useStyles()

  return (
    <Button
      {...props}
      variant="contained"
      className={classes.root}
      endIcon={<DownloadIcon viewBox="0 0 112 111" />}
    >
      {children}
    </Button>
  )
}

export default DownloadButton
